import * as React from 'react';
import { overrideCSS } from '../../utils/function';

const FaAngleDown = require('react-icons/lib/fa/angle-down');
const internalStyles = require('./BackToTop.pcss');

interface IState {
    visible: boolean;
}

interface IProps {
    isLoading?: boolean;
    onClick?: any;
    styles?: Object;
}

export class BackToTop extends React.Component<IProps, IState>{

    constructor(props) {
        super(props);
        this.animateToTop = this.animateToTop.bind(this);
    }

    animateToTop(e) {
    e.preventDefault();
    var scrollToTop = window.setInterval(function() {
        var pos = window.pageYOffset;
        if ( pos > 0 ) {
            window.scrollTo( 0, pos - 100 );
        } else {
            window.clearInterval( scrollToTop );
        }
    }, 0);
  }

    render() {

        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;

        let internalClasses = {
            caret: `${styles.caret}`,
        }

        return (
            <div className={styles.backtotop}>
                <a onClick={this.animateToTop}>
                    <div className={styles.backtotoptext}>Back To Top</div>
                    <div className={internalClasses.caret}><FaAngleDown /></div>
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/BackToTop/BackToTop.tsx